/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Months_SeptemberInputs */

const es_months_september = /** @type {(inputs: Months_SeptemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Septiembre`)
};

const en_months_september = /** @type {(inputs: Months_SeptemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`September`)
};

/**
* | output |
* | --- |
* | "September" |
*
* @param {Months_SeptemberInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const months_september = /** @type {((inputs?: Months_SeptemberInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Months_SeptemberInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_months_september(inputs)
	return en_months_september(inputs)
});
export { months_september as "months.september" }